<template>
  <edit-sidebar>
    <div class="part">
      <h2>Meeting Title</h2>
      <form class="basics sentry-masked-text" @submit.prevent @keyup.enter.exact="saveAndReturn">
        <app-auto-textarea late-focus="true" :modelValue="field" placeholder="Add Meeting Title..." :limit="255" @update:modelValue="handleInput" />
        <app-text-limit-message :limit="255" :warn-limit="200" :value="field" />
      </form>
      <div class="actions btn-pair">
        <button type="button" @click.prevent="cancel()">Cancel</button>
        <button type="button" @click.prevent="saveAndReturn()">Save</button>
      </div>
    </div>
  </edit-sidebar>
</template>

<script setup>
import { ref, watch, nextTick, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import AppAutoTextarea from '@/components/AppAutoTextarea.vue';
import AppTextLimitMessage from '@/components/AppTextLimitMessage';
import EditSidebar from '@/components/EditSidebar.vue';
import { useSidebarStore } from '@/store/pinia/sidebar';
import { useMeetingStore } from '@/store/pinia/meeting';
import utils from '../resources/utils.js';

const props = defineProps({
  focusing: {
    type: Boolean,
    default: false,
  },
  extra: {
    type: Boolean,
    default: false,
  },
});
const { $meetingmanager } = getCurrentInstance().appContext.config.globalProperties;
const meetingStore = useMeetingStore();
const sidebarStore = useSidebarStore();

const field = ref('');
const { name: fieldContent } = storeToRefs(meetingStore);

watch(
  fieldContent,
  (nv) => {
    field.value = utils.desanitizeString(nv);
  },
  { immediate: true },
);

function handleInput(e) {
  field.value = e;
}
function saveAndReturn() {
  meetingStore.updateLocalMeetingInfo({ prop: 'name', value: field.value || '' });
  $meetingmanager.updateMeeting({
    name: field.value || '',
    trigger: 'name',
  });
  nextTick(() => {
    sidebarStore.finishedWithPane(props.extra);
  });
}
function cancel() {
  sidebarStore.finishedWithPane(props.extra);
}
</script>
